import { Button } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { useState } from "react";

export const NoticeDetail = () => {
  const history = useHistory();
  const location = useLocation();
  const [notice] = useState(location.state?.notice);

  return (
    <div className="max-w-[1400px] mx-auto">
      <div className="p-6 rounded-xl bg-white shadow-md">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-4xl font-semibold text-black mb-1">{notice.title}</h1>
            <div className="text-lg text-[#4E4E4E]">{notice.created_at}</div>
          </div>
          <Button onClick={() => history.goBack()}>목록보기</Button>
        </div>
        <hr className="border-[#adadad] my-4" />
        <div className="text-2xl whitespace-pre-wrap text-black my-6">
          {notice.description}
        </div>
      </div>
    </div>
  );
};
